import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';

export const buildCreateAccountUsersRequest = (accountId, usersData) => [
  `${getAdminApiUrl()}/v1/accounts/${accountId}/users:import`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(usersData),
  },
];

export const buildGetAccountRolesRequest = (accountId, name) =>
  `${getAdminApiUrl()}/v1/accounts/${accountId}/roles?limit=200&sort=name${
    name ? `&filter[name]=${name}` : ''
  }`;

export const filterActiveRoles = (response) =>
  response.filter((role) => role.status === 'active');
